import React, { Component } from 'react';
import { Auth, API } from 'aws-amplify';
import { withStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CardContent from '@material-ui/core/CardContent';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import { withSnackbar } from 'hooks/useSnack';

const FormItem = Form.FormItem;

const styles = (theme) => ({
  root: {
    'maxWidth': 460,
    'margin': '15px auto 30px',
    '& .MuiFormControl-root': {
      marginBottom: theme.spacing(1.5),
    },
    '& .MuiButton-sizeLarge': {
      padding: '15px 22px',
    },
  },
  title: {
    marginBottom: theme.spacing(1.5),
  },
});

class ForgotPassword extends React.Component {
  state = {
    username: '',
    delivery: false,
  };

  onUsernameChange = (e) => {
    this.setState({
      username: e.target.value.trim(),
    });
  };

  onSend = () => {
    const { username } = this.state;
    return Auth.forgotPassword(username)
      .then((data) => {
        this.setState({ delivery: data.CodeDeliveryDetails });
      })
      .catch((err) => {
        if (err.code === 'NotAuthorizedException') {
          return API.post('public', `/users/reset_password`, {
            body: {
              username,
            },
          })
            .then(
              () => {
                return Auth.forgotPassword(username).then((data) => {
                  this.setState({ delivery: data.CodeDeliveryDetails });
                });
              },
              (e) => {
                throw new Error(
                  e.response ? e.response.data.message : e.message,
                );
              },
            )
            .catch(this.error);
        } else {
          this.error(err);
        }
      });
  };

  error = (err) => {
    const { snackbar } = this.props;
    snackbar.error(err.message);
  };

  handleFormSubmission = (evt) => {
    evt.preventDefault();
    return this.props.form.validateFields().then(this.onChangePassword);
  };

  onChangePassword = (values) => {
    const { username } = this.state;
    const { snackbar } = this.props;
    return Auth.forgotPasswordSubmit(username, values.code, values.password)
      .then((data) => {
        snackbar.success('Password successfully changed. Please login');
        this.setState({ delivery: null });
        this.changeState('signIn');
      })
      .catch((err) => this.error(err));
  };

  changeState(state, data) {
    if (this.props.onStateChange) {
      this.props.onStateChange(state, data);
    }
  }

  renderSendCode = () => {
    return (
      <>
        <Input
          placeholder="username"
          value={this.state.username}
          onChange={this.onUsernameChange}
        />
        <Box marginBottom={2}>
          <Button
            fullWidth
            disabled={!this.state.username}
            variant="contained"
            color="primary"
            size="large"
            onClick={this.onSend}
          >
            Send code
          </Button>
        </Box>
        <Typography>
          <Link href="#" onClick={() => this.changeState('signIn')}>
            Back to Sign In
          </Link>
        </Typography>
      </>
    );
  };

  renderPasswordView = () => {
    const { form, classes, authState } = this.props;
    const { delivery } = this.state;
    const { getFieldDecorator } = form;
    return (
      <Form onSubmit={this.handleFormSubmission} autoComplete="off">
        <Alert severity="success">
          Verification code has been sent to your registered email address.
        </Alert>
        <br />
        <FormItem>
        {getFieldDecorator('hidden', {
            rules: [{ required: false }],
          })(<Input style={{display:'none'}} />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('code', {
            rules: [{ required: true }],
          })(<Input placeholder="Code" autoComplete="off" />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true }],
          })(
            <Input
              placeholder="New Password"
              type="password"
              autoComplete="new-password"
            />,
          )}
        </FormItem>
        <Box marginBottom={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            onClick={this.handleFormSubmission}
          >
            Submit
          </Button>
        </Box>
        <Typography variant="subtitle2">
          <Link href="#" onClick={this.onSend}>
            Resend Code
          </Link>
        </Typography>
      </Form>
    );
  };

  render() {
    const { classes, authState } = this.props;
    const { delivery } = this.state;
    if (authState !== 'forgotPassword') return null;

    return (
      <Box className={classes.root}>
        <CardContent>
          <Typography className={classes.title}>Reset your password</Typography>
          {delivery ? this.renderPasswordView() : this.renderSendCode()}
        </CardContent>
      </Box>
    );
  }
}

export default Form.create()(withStyles(styles)(withSnackbar(ForgotPassword)));
